import { ExampleGallery } from '../components/ExampleGallery';
import { LandingSeoContent } from '../components/LandingSeoContent';
import { UploadDropzone } from '../components/UploadDropzone';
import { useEffect } from 'react';
import { usePhoto } from '../context/PhotoContext';
import { createDemoFile } from '../lib/demo';

export function HomePage(): JSX.Element {
  const { loadFiles } = usePhoto();

  useEffect(() => {
    if (new URLSearchParams(window.location.search).get('demo') === '1') {
      void createDemoFile().then((file) => loadFiles([file]));
      return;
    }

  }, [loadFiles]);

  return (
    <main>
      <div className="mx-auto max-w-7xl px-4 pt-10 sm:px-6 sm:pt-14">
        <UploadDropzone />
      </div>
      <ExampleGallery />
      <LandingSeoContent />
    </main>
  );
}
